import APIClient from '@/shared/http/clients/api'

const resourceName = 'parametros-movimentacao'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const GetAllSituacao = (situacao, config = {}) => APIClient.get(`${APICore}/${resourceName}/?situacao=${situacao}&sort=name,asc&size=500`, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)

const MovimentationCarRepository = {
  GetAll,
  GetAllSituacao,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete,
  Search
}

export default MovimentationCarRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/movimentationCards.js